import { FC } from 'react';
import { UseFormRegister } from 'react-hook-form';
import { FormControl, FormLabel, SimpleGrid } from '@chakra-ui/react';

import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';
import { CurrentSystemVersionFormBase } from '../../FormBases';

type Props = {
  register: UseFormRegister<CustomerFormFields>;
};

/**
 * 編集モーダル用のシステムの現在バージョンのフォームです。
 */
export const CurrentSystemVersionForm: FC<Props> = ({ register }) => (
  <FormControl>
    <SimpleGrid templateColumns="1fr 2fr">
      <FormLabel>システムの現在バージョン</FormLabel>
      <CurrentSystemVersionFormBase register={register} />
    </SimpleGrid>
  </FormControl>
);
